import { window } from '../global';

export default {
  gtag: window.gtag ?? (() => { }),
};